import {Checkbox} from '@fluentui/react';
import React from "react";
import {addElement, setOnPremiseState} from "../../../actions/CreateSiteActions/createSiteActions";
import {connect} from "react-redux";
import {
    ADD_CONFIDENTIALITY, ADD_EXTERNALCOLLABORATION,
    ADD_ONLINE_LOCATION, SET_ORDER_CREATED,
    ADD_QUOTA, ADD_LOCATION} from "../../../actions/types";
import DisplayMessage from "../DisplayMessage";

import { LocationType, ConfidentialityLevel } from "../../../GlobalConst/globalEnums";

class ConfidentialityLevels extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            error: null
        }
    }

    handleSelection(e)
    {
        let value = e.target.id;
        let locationType;
        this.props.sendElement(ADD_CONFIDENTIALITY, {key:value, value:value});
        this.props.sendElement(SET_ORDER_CREATED, false);

        if(value === ConfidentialityLevel.strictlyConfidential)
        {
            locationType = LocationType.onPremise;
            this.props.setOnpremise(true);
            this.props.sendElement(ADD_ONLINE_LOCATION,false);
            this.props.sendElement(ADD_EXTERNALCOLLABORATION, false);
        }
        else 
        {
            locationType = LocationType.online;
            this.props.setOnpremise(false);
            this.props.sendElement(ADD_ONLINE_LOCATION,true);
        }

        const defaultLocation = this.props.locations.filter(x => x.locationType === locationType && x.default)[0];
        const defaultQuota = this.props.quotas.filter(x => x.locationId === defaultLocation.id && x.default && x.active)[0];

        this.props.sendElement(ADD_LOCATION, defaultLocation);
        this.props.sendElement(ADD_CONFIDENTIALITY, value);
        
        if(this.props.quotaSize === null || (this.props.onlineLocation !== (locationType === LocationType.online)))
            this.props.sendElement(ADD_QUOTA, defaultQuota.quotaSize);

    }

    render() {
        const choices = this.props.confidentialityLevels.map(item => 
            <div key={item.key} style={{marginBottom:'4px'}} className='cLevel-checkbox'>
                <Checkbox 
                    id={item.value} 
                    label={item.value} 
                    disabled={this.props.blockedGroupEmployee } 
                    checked={item.value === this.props.confidentiality} 
                    onChange={this.handleSelection.bind(this)}/>
            </div>);
        
        const error = this.props.possibleWarning && !this.props.confidentiality && 
            <div className='errorMessage'>Please select an option</div>;

        return (
            <div className='confidentiality'>
                {choices}
                <DisplayMessage error = {this.state.error}/>
                {error}
            </div>
        );
    }
}
const mapActionsToProps = {
    sendElement : addElement,
    setOnpremise: setOnPremiseState,
}

const mapStateToProps = state => ({
    confidentiality: state.newSite.Confidentiality,
    possibleWarning: state.wizard.nextStepRequested,
    onlineLocation: state.newSite.OnlineLocation,
    confidentialityLevels: state.app.siteConfidentialityLevels,
    quotas: state.app.siteQuotas,
    locations: state.app.siteLocations,
    quotaSize: state.newSite.QuotaSize
})

export default connect(mapStateToProps,mapActionsToProps)(ConfidentialityLevels);






// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/ConfidentialityLevels.js